    <template>
    <div id="ag-grid-demo">
        <div class="vx-row">
            <div class="vx-col w-1/3">
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Client ID</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-select
                            class="selectExample"
                            v-model="form.client_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, client)"
                        >
                            <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                        </vs-select>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Warehouse ID</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-select
                            class="selectExample"
                            v-model="form.warehouse_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, warehouse)"
                        >
                            <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                        </vs-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-1/2">
                <vs-card class="cardx">
                    <div slot="header">
                        <h3>
                            Warehouse Throughput
                        </h3>
                        <p>Inbound and Outbound By Quantity</p>
                    </div>
                    <e-charts autoresize :options="inbound_bar" ref="bar" theme="ovilia-green" auto-resize />
                </vs-card>
            </div>
            <div class="vx-col w-1/2">
                <vs-card class="cardx">
                    <div slot="header">
                        <h3>
                            IM Inventory
                        </h3>
                    </div>
                    <!-- <e-charts autoresize :options="inventory_bar" ref="bar" theme="ovilia-green" auto-resize />                 -->
                </vs-card>
            </div>
        </div>
         <div class="vx-row">
            <div class="vx-col w-1/2">
                <vs-card class="cardx">
                    <div slot="header">
                        <h3>
                            Good Receiving
                        </h3>
                    </div>
                    <!-- <e-charts autoresize :options="gr_pie" auto-resize /> -->
                </vs-card>
            </div>
            <div class="vx-col w-1/2">
                <vs-card class="cardx">
                    <div slot="header">
                        <h3>
                            Delivery Order
                        </h3>
                    </div>
                    <!-- <e-charts autoresize :options="do_pie" auto-resize /> -->
                </vs-card>
            </div>
        </div>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";

import ECharts from 'vue-echarts/components/ECharts';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/chart/pie';
import 'echarts/lib/chart/bar';
import vSelect from "vue-select";


// ECharts.registerTheme('ovilia-green', theme)

export default {
    components: {
        ECharts,
        vSelect
    },
    data() {
        return {
            gridOptions: {},
            gridApi: null,
            data: [],
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
            warehouse: {
                data: [],
                loading: false,
                endpoint: 'master/warehouses',
                objectKey: 'warehouses_code'
            },
            form: {
                clien_id: null,
                warehouse_id: null
            },
            isLoading: false,  
            // Pagination
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,          
            //start bar chart inbound
            inbound_bar: {
                legend: {},
                tooltip: {},
                dataset: {
                // Provide data.
                source: [
                    ['product', 'Inbound', 'Outbound'],
                    // [...this.one_inbound.date],
                    [this.fetchData()],
                    [this.fetchData()],
                    ['11-12-2019', '1', '3']
                    // ['11-12-2019', ...this.randomize()],
                    // ['12-12-2019', ...this.randomize()]
                ]
            },
            inventory_bar : {},
            // Declare X axis, which is a category axis, mapping
            // to the first column by default.
            xAxis: { type: 'category' },
            // Declare Y axis, which is a value axis.
            yAxis: {},
            // Declare several series, each of them mapped to a
            // column of the dataset by default.
            series: [{ type: 'bar' }, { type: 'bar' }]
            }
        }
    },
    watch: {
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        },
    },
    methods: {
        //start bar chart inbound
        // randomize() {
        //     return [0, 0, 0].map(v => {
        //         return Math.round(300 + Math.random() * 65000) / 25
        //     })
        // },
        //end bar chart inbound
        fetchData() {
            this.isLoading = true
            Promise.all([
            this.$http.get('report/operationdashboard'),
            this.$http.post("master/clients"),
            this.$http.post("master/warehouses")
            ])
            .then(
                this.$http.spread((res, client, warehouse) => {
                    // console.log(this.client.data);
                    this.data = res.data.data;
                    this.client.data = client.data.data;
                    this.warehouse.data = warehouse.data.data;
                    this.totalPage = res.data.last_page;
                    this.currentPage = this.currentPage;
                    this.dataTotal = res.data.total;
                    this.dataFrom = res.data.from;
                    this.dataTo = res.data.to;
                    // const warehouse_throughput = 
                    //     [
                    //         'Inbound'
                    //     ]
                    // this.data= warehouse_throughput;
                    // this.inbound_bar.dataset.source[1] = warehouse_throughput;
                    // this.inbound_bar.dataset.source[2] = xwarehouse_throughput;
                })
            )
            .catch(error => console.log(error))
            .then(() => this.isLoading = false)
        }
    },
    mounted() {
        this.fetchData()
    }
}

</script>